// Report types a contractor produces, grouped the way a contractor thinks about
// them. Keys align with COMPLIANCE_SPEC in utils/compliance.js wherever a report
// corresponds to a compliance area, so a client's reporting config lines up with
// the compliance grid on the property record.
//
// `statutory: true` marks reports that exist to satisfy a legal duty — those get
// a warning when a client asks for a stripped-down version, because required
// content can't be configured away.

export const REPORT_TYPES = [
  {
    group: 'Inspection & test certificates',
    items: [
      { key: 'anchor_test', label: 'Anchor / fall-arrest test certificate', statutory: true,
        hint: 'Fall-protection anchor testing and certification' },
      { key: 'loler_examination', label: 'LOLER thorough examination report', statutory: true,
        hint: 'Lifting equipment — davits, cradles, hoists' },
      { key: 'puwer_inspection', label: 'PUWER inspection report', statutory: true },
      { key: 'emergencyLighting', label: 'Emergency lighting test certificate', statutory: true },
      { key: 'fire_extinguisher', label: 'Fire extinguisher service record', statutory: true },
      { key: 'eicr', label: 'Electrical installation condition report (EICR)', statutory: true },
      { key: 'gasSafety', label: 'Gas safety record (CP12)', statutory: true },
    ],
  },
  {
    group: 'Assessments & surveys',
    items: [
      { key: 'fireRiskAssessment', label: 'Fire risk assessment (FRA)', statutory: true },
      { key: 'wahReview', label: 'Working-at-height review' },
      { key: 'riskInspection', label: 'Risk inspection' },
      { key: 'rreReview', label: 'Rescue & emergency plan review' },
      { key: 'legionella', label: 'Legionella / water risk assessment', statutory: true },
      { key: 'fireDoorInspection', label: 'Fire door inspection report', statutory: true },
      { key: 'wcas', label: 'Water compliance assessment' },
    ],
  },
  {
    group: 'Operational',
    items: [
      { key: 'job_completion', label: 'Job completion report',
        hint: 'What was done on site, issued after each visit' },
      { key: 'remedial_quote', label: 'Remedial works report' },
      { key: 'compliance_summary', label: 'Compliance summary',
        hint: 'Portfolio-level status across the client’s buildings' },
      { key: 'incident', label: 'Incident report' },
      { key: 'asset_register', label: 'Asset register export' },
    ],
  },
];

/** Flat lookup: key → { label, statutory, group }. */
export const REPORT_TYPE_INDEX = REPORT_TYPES.reduce((acc, g) => {
  g.items.forEach((i) => { acc[i.key] = { ...i, group: g.group }; });
  return acc;
}, {});

export const BRANDING_OPTIONS = [
  ['contractor', 'Your branding'],
  ['client', 'Client branding'],
  ['cobranded', 'Co-branded'],
  ['cloudsafe', 'CloudSafe branding'],
];

export const DELIVERY_OPTIONS = [
  ['email', 'Email'],
  ['portal', 'Client portal only'],
  ['both', 'Email + portal'],
  ['manual', 'Manual — do not send automatically'],
];

export const PHOTO_OPTIONS = [
  ['appendix', 'Photo appendix at the back'],
  ['inline', 'Photos inline with findings'],
  ['separate', 'Photos delivered as a separate file'],
  ['none', 'No photos'],
];

export const STRUCTURED_OPTIONS = [
  ['none', 'PDF only'],
  ['json', 'JSON alongside the document'],
  ['csv', 'CSV alongside the document'],
  ['api', 'Push to the client’s system'],
];

export const OUTPUT_FORMATS = [['pdf', 'PDF'], ['docx', 'Word'], ['xlsx', 'Excel'], ['html', 'HTML']];

export const SUB_FREQUENCIES = [
  ['weekly', 'Weekly'], ['monthly', 'Monthly'], ['quarterly', 'Quarterly'], ['annually', 'Annually'],
];
